/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description GeoLocation selectors
 */

import { createSelector } from '@zcode/memoizers'
import type { GeoLocation } from './GeoLocation'

export const selectCityName = (geoLocation: GeoLocation) => geoLocation?.cityName

export const selectStateName = (geoLocation: GeoLocation) => geoLocation?.stateName

export const selectUrl = (geoLocation: GeoLocation) => geoLocation?.url

export const selectLat = (geoLocation: GeoLocation) => geoLocation?.lat

export const selectLng = (geoLocation: GeoLocation) => geoLocation?.lng

export const selectCenter = createSelector(selectLat, selectLng, (lat, lng) => ({ lat, lng }))

export const selectCountry = (geoLocation: GeoLocation) => geoLocation?.country
